import React from 'react';

import { ERROR_IMAGE } from 'settings';
import formatCurrency from 'utils/formatCurrency';

import Typography from '@eduzz/houston-ui/Typography';

import { Image, Price, ProductDetails, ProductInfoContainer, Box, ProductTitle } from './styles';

interface IProps {
  product?: {
    offerKey: string;
    contentId: number;
    image: string;
    title: string;
    price: number;
  };
}

const ProductInfo: React.FC<IProps> = ({ product }) => {
  if (!product) {
    return null;
  }

  const { offerKey, image, title, price, contentId } = product;

  return (
    <ProductInfoContainer>
      <Image
        src={image}
        alt={title}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = ERROR_IMAGE;
        }}
      />
      <ProductDetails>
        <Box size='xxs'>#{offerKey ? offerKey : contentId}</Box>
        <Typography size='xs' weight='semibold' color='neutralColor.low.dark'>
          <ProductTitle>{title}</ProductTitle>
        </Typography>
        <Price size='xs'>{formatCurrency(price)}</Price>
      </ProductDetails>
    </ProductInfoContainer>
  );
};

export default React.memo(ProductInfo);
